import React, { useEffect, useState, useRef } from "react";
import PackageJson from "../../../package.json";
import { DefaultLayout } from "../../layouts/DefaultLayout";
import { WowseeAvatar } from "../../components/Avatar";
import { userService } from "../../services/user.service";
import { userStore } from "../../gStore/user.store";
import { ActivityCard } from "../../components/atoms/ActivityCard";
import { HighscoreGame } from "../../components/atoms/HighscoreGame";
import { Col } from "antd";
import { useDraggable } from "react-use-draggable-scroll";
import { gameService } from "../../services/game.service";
import { CardGames } from "../../components/atoms/GameCard";

function Account1() {
  const [loadingRecentActivities, setLoadingRecentActivities] =
    useState<boolean>(true);
  const [loadingHighscore, setLoadingHighscore] = useState<boolean>(true);
  useEffect(() => {
    if (userStore.data.user.id) {
      userService
        .gameHistory(userStore.data.user.id)
        .then((gameHistory) => {
          userStore.setGameHistory({ payload: { gameHistory } });
        })
        .catch((errMessage: string) => {
          console.log(errMessage);
        })
        .finally(() => {
          setTimeout(() => {
            setLoadingRecentActivities(false);
          }, 500);
        });
      userService
        .loadHighscore(userStore.data.user.id)
        .then((highscoreGames) => {
          userStore.setHighscoreGames({ payload: { highscoreGames } });
        })
        .finally(() => {
          setTimeout(() => {
            setLoadingHighscore(false);
          }, 500);
        });
      gameService
        .getFavoriteGames(userStore.data.user.id)
        .then((favoriteGames) => {
          userStore.setFavoriteGames({ payload: { games: favoriteGames } });
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStore.data.user.id]);

  const ref1 =
    useRef<HTMLElement>() as React.MutableRefObject<HTMLInputElement>;
  const { events: events1 } = useDraggable(ref1);
  const ref2 =
    useRef<HTMLElement>() as React.MutableRefObject<HTMLInputElement>;
  const { events: events2 } = useDraggable(ref2);
  return (
    <>
      <DefaultLayout title="Account">
        <section className="py-8">
          <div className="container">
            <div className="w-full flex gap-4">
              <div className="text-white bg-light-dark1 px-2 rounded-xl w-60">
                <div className="flex space-x-2 items-center justify-center">
                  <div className="flex flex-col items-center gap-4 m-5 my-10 mx-auto px-4">
                    <WowseeAvatar editable />
                    <p className="text-xl text-center">
                      {userStore.data.user.first_name} {userStore.data.user.last_name}
                    </p>
                  </div>
                </div>
              </div>
              <div className="grow shrink text-white bg-light-dark2 p-4 rounded-xl">
                <p className="font-bold text-xl leading-6 text-white mb-6">
                  Recent Activity
                </p>
                {loadingRecentActivities && (
                  <div className="w-full h-full flex justify-center items-center">
                    Loading
                  </div>
                )}
                <div
                  className="flex space-x-2 items-center justify-start overflow-x-auto gap-4 max-w-[1000px] scrolStyle"
                  ref={ref1}
                  {...events1}
                >
                  {userStore.data.gameHistory.length === 0 ? (
                    <div className="text-center min-h-[200px] w-full bg-[#282A2D] rounded-lg flex items-center justify-center">
                      <div className="text-center">
                        <img
                          src={PackageJson.homepage + "/icons/Icon (2).svg"}
                          className="mx-auto mb-3"
                          alt="icon"
                        />
                        <h4 className="font-bold text-[20px] text-white mb-2">
                          No Activity Found!
                        </h4>
                        <p className="text-[16px] text-white mb-6">
                          Your recently played games will <br /> appear here.
                        </p>
                      </div>
                    </div>
                  ) : (
                    userStore.data.gameHistory.map((gameHistory, id) => (
                      <ActivityCard key={id} game={gameHistory.game} />
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-8">
          <div className="container">
            <p className="text-xl text-white font-bold mb-6 w-full">
              Favorite Games
            </p>
            <div
              className="flex space-x-2 items-center justify-start overflow-x-auto gap-4 scrolStyle"
              style={{ display: loadingRecentActivities ? "none" : "flex" }}
              ref={ref2}
              {...events2}
            >
              {userStore.data.favoriteGames?.length === 0 ? (
                <div className="text-center min-h-[300px] w-full bg-[#282A2D] rounded-lg flex items-center justify-center">
                  <div className="text-center">
                    <img
                      src={PackageJson.homepage + "/icons/Icon (2).svg"}
                      className="mx-auto mb-3"
                      alt="icon"
                    />
                    <h4 className="font-bold text-[20px] text-white mb-2">
                      No Games Favorited
                    </h4>
                    <p className="text-[16px] text-white mb-6">
                      Your favorite games will appear here.
                    </p>
                  </div>
                </div>
              ) : (
                userStore.data.favoriteGames?.map((game, id) => (
                  <Col span={6}>
                    <CardGames
                      key={id}
                      game={game}
                      displayLike={false}
                      displayFavorite={false}
                    />
                  </Col>
                ))
              )}
            </div>
          </div>
        </section>
        <section className="py-8">
          <div className="container">
            <p className="text-xl text-white font-bold mb-6 w-full">
              High Scores
            </p>
            {loadingHighscore && (
              <div className="w-full h-full flex justify-center items-center">
                Loading
              </div>
            )}
            <div
              className="flex space-x-2 items-center justify-start overflow-x-auto gap-4 scrolStyle"
              style={{ display: loadingRecentActivities ? "none" : "flex" }}
              ref={ref2}
              {...events2}
            >
              {userStore.data.highscoreGames.length === 0 ? (
                <div className="text-center min-h-[300px] w-full bg-[#282A2D] rounded-lg flex items-center justify-center">
                  <div className="text-center">
                    <img
                      src={PackageJson.homepage + "/icons/Icon (2).svg"}
                      className="mx-auto mb-3"
                      alt="icon"
                    />
                    <h4 className="font-bold text-[20px] text-white mb-2">
                      No Scores Found!
                    </h4>
                    <p className="text-[16px] text-white mb-6">
                      Your scores from the games will <br /> appear here.
                    </p>
                  </div>
                </div>
              ) : (
                userStore.data.highscoreGames.map((highscoreGame) => (
                  <Col span={6}>
                    <HighscoreGame {...highscoreGame} />
                  </Col>
                ))
              )}
            </div>
          </div>
        </section>
      </DefaultLayout>
    </>
  );
}

export default Account1;
